/* eslint-disable react-hooks/exhaustive-deps */
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import { HTML as _HTML } from "../../contentType"
import DataDummy from "../../landing-edit/DataDummy"
import { IDataComponentsProps } from "../DataComponents" 
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { setHorizontalAlignToCSSRule } from "../Section"
import { ALIGN } from "src/modules/pe-landing-module/data/interfaces"
import { DataContentAnimateContainer } from "./DataContentAnimateContainer"
import { DataContentPositionContainer } from "./DataContentPositionContainer"

/* Protopia Ecosystem component */
export interface ISectionColumnsProps extends IDataComponentsProps {
   
}
const SectionColumns = (props: ISectionColumnsProps): JSX.Element => {
    const section = props.section
    const composition = useComposition( section )
    
    useEffect(() => {
        addCSSClass(
            `section-columns-container-${props.section.id}`,
            `.section-columns-container-${props.section.id} {
                ${setHorizontalAlignToCSSRule(props.section.vertical_align || ALIGN.MIDDLE )};
            }`
        )
        return () => {
            removeCSSClass( `section-columns-container-${props.section.id}` )
        }
    }, [])
    return <div 
        className={ `landing-data-components-container landing-edit-cont section-columns p-0 ${section.className || ""} section-${ composition.columns } section-columns-container-${props.section.id}` }  
        style={{...section.dstyle, gap: section.gap }} 
        data-proportia={composition.proportia?.join(",")}
    >
       {
            props.data.map((data, i) => { 
                if(data.isHidden) {
                    return <DataDummy key={ data.id } data={data} section={props.section} />
                }
                const type = data.type
                const DataComponent = type && components()[ type ]
                    ?
                    components()[ type ].c
                    :
                    _HTML 
                return <DataContentAnimateContainer {...props} i={ i } key={ data.id } proportia={ !!composition.proportia ? composition.proportia[i] : 100 / composition.columns }>
                    <DataContentPositionContainer {...props} i={i} section={{ ...props.section, className:` w-100 ${props.section.className}`}}>
                        <DataComponent  
                            section={ section } 
                            data={ { ...data, type } } 
                        /> 
                    </DataContentPositionContainer>
                </DataContentAnimateContainer>
            })
        }
    </div>
}
export default SectionColumns